export const VIEW = { HIDDEN: 'hidden', BANNER: 'banner', MANAGE: 'manage' };

// Every undecided visitor sees the notice, in every posture: it IS the notice
// that engagement-based tracking rests on ("we told you, you kept browsing"),
// so it has to be on screen before any implied grant can fire. A recorded
// decision — explicit or implied — hides it, and the "Your Privacy Choices"
// link reopens the settings center on demand.
export function restingViewFor({ decided }) {
  return decided ? VIEW.HIDDEN : VIEW.BANNER;
}
